module.exports = "/static/assets/0611d215fe34175ddbab01f4f48f3517.jpg";